import _ from 'lodash'
import $ from 'jquery'
import Hammer from 'hammerjs'
import 'jquery-hammerjs'

const createjs = window.createjs

export default class MCAnimations {

  constructor (stage, exportRoot, canvas, actions) {
    this.actions = actions;
    this.stage = stage;
    this.exportRoot = exportRoot;
    const container = exportRoot.container;
    const container_up = exportRoot.container_up;
    this.canvas = canvas

    this.initBears(container.bears, container_up.intro);
    this.initMogura(container.mogura);
    this.initHouse1(container.house_1, exportRoot.modals);
    this.initHouse2(container.house_2);
    // this.initCursor(exportRoot.arrow);
    this.initMoveCursor(exportRoot.move_arrow_l, exportRoot.move_arrow_r);

    const fukidashi = container.fukidashi;
    this.initFukidashi([
      {
        btn: container.fox,
        fukidashi: fukidashi.fukidashi_fox
      },
      {
        btn: container.tanuki,
        fukidashi: fukidashi.fukidashi_tanuki
      }, {
        btn: container.ja,
        fukidashi: fukidashi.fukidashi_ja
      },
    ]);
    stage.enableMouseOver();
    exportRoot.board.dispatchEvent("mouseup")
  }

  initBears (bears, intro) {
    if (!bears.numChildren) {
      setTimeout(() => {
        this.initBears(bears, intro)
      }, 100)
    } else {
      for (let j = 1; j <= 11; j++) {
        let _bear = bears[ `bear_${j}` ];
        const _intro = intro[ `intro_${j}` ]
        if (j === 7 || j === 8) {
          _bear = bears.bear_7[ `bear_${j}` ]
        }
        _bear.cursor = "pointer";
        if (j === 7) {
          this.disabledDrag(_bear);
          _bear.addEventListener("click", (e) => {
            // if(this.canvas.isMouseDown)return;
            _bear.parent.gotoAndPlay(1);
            if (!_intro.visible) {
              for (let k = 1; k <= 11; k++) {
                if (j !== k) {
                  intro[ `intro_${k}` ].visible = false;
                }
                intro[ `intro_${k}` ].scaleX = intro[ `intro_${k}` ].scaleY = 0;
              }
              _intro.visible = true;
              createjs.Tween.get(_intro).wait(500).to({ scaleX: 1, scaleY: 1 }, 600, createjs.Ease.backOut)
            }
            e.preventDefault();
            e.stopPropagation();
          });
        } else if (j === 8) {
          this.disabledDrag(_bear);
          _bear.addEventListener("click", (e) => {
            // if(this.canvas.isMouseDown)return;
            _bear.parent.gotoAndPlay("aka");
            if (!_intro.visible) {
              for (let k = 1; k <= 11; k++) {
                if (j !== k) {
                  intro[ `intro_${k}` ].visible = false;
                }
                intro[ `intro_${k}` ].scaleX = intro[ `intro_${k}` ].scaleY = 0;
              }
              _intro.visible = true;
              createjs.Tween.get(_intro).wait(500).to({ scaleX: 1, scaleY: 1 }, 600, createjs.Ease.backOut)
            }
            e.preventDefault();
            e.stopPropagation();
          });
        } else {
          this.disabledDrag(_bear);
          _bear.addEventListener("click", (e) => {
            // if(this.canvas.isMouseDown)return;
            _bear.gotoAndPlay(1);
            if (!_intro.visible) {
              for (let k = 1; k <= 11; k++) {
                if (j !== k) {
                  intro[ `intro_${k}` ].visible = false;
                }
                intro[ `intro_${k}` ].scaleX = intro[ `intro_${k}` ].scaleY = 0;
              }
              _intro.visible = true;
              let duration = (j === 3) ? 800 : 500;
              createjs.Tween.get(_intro).wait(duration).to({ scaleX: 1, scaleY: 1 }, 600, createjs.Ease.backOut)
            }
            e.preventDefault();
            e.stopPropagation();
          });
        }

        _intro.cursor = "pointer";
        this.disabledDrag(_intro);
        _intro.addEventListener("click", () => {
          // if(this.canvas.isMouseDown)return;
          if (_intro.visible) {
            _intro.visible = false;
            _intro.scaleX = _intro.scaleY = 0;
          }
        })

      }
    }
  }

  initFukidashi (fukidashiList) {
    // console.log(fukidashiList)
    _.each(fukidashiList, (obj) => {
      const fuki = obj.fukidashi
      const btn = obj.btn
      fuki.scaleX = fuki.scaleY = 0
      fuki.visible = false
      // const pos = fuki.getBounds()
      // fuki.regX = pos.width
      // fuki.regY = pos.height
      // fuki.x = pos.width
      // fuki.y = pos.height
      // console.log(pos)

      btn.cursor = "pointer";
      fuki.btn_close.cursor = "pointer";
      fuki.cursor = "auto";
      this.disabledDrag(fuki);
      fuki.btn_close.addEventListener("click", (e) => {
        // if(this.canvas.isMouseDown)return;
        fuki.scaleX = fuki.scaleY = 0
        fuki.visible = false;
        e.preventDefault();
        e.stopPropagation();
      });
      this.disabledDrag(btn);

      btn.addEventListener("click", () => {
        // if(this.canvas.isMouseDown)return;
        if (!fuki.visible) {
          fuki.scaleX = fuki.scaleY = 0
          fuki.visible = true;
          if (fuki.totalFrames >= 2) {
            const frame = Math.floor(Math.random() * fuki.totalFrames)
            fuki.gotoAndStop(frame)
          }
          createjs.Tween.get(fuki).to({ scaleX: 1, scaleY: 1 }, 600, createjs.Ease.backOut)
        }
      })

      if (fuki.totalFrames >= 2) {
        const frame = Math.floor(Math.random() * fuki.totalFrames)
        fuki.gotoAndStop(frame)
        fuki.currentFrame = frame
        fuki.cursor = "pointer"
        this.disabledDrag(fuki);

        fuki.addEventListener("click", () => {
          // if(this.canvas.isMouseDown)return;
          const cf = fuki.currentFrame
          const tf = fuki.totalFrames
          if (cf < tf - 1) {
            fuki.gotoAndStop(cf + 1)
          } else {
            fuki.gotoAndStop(0)
          }
        })
      }

    })
  }

  initMogura (mogura) {
    this.disabledDrag(mogura);
    mogura.cursor = "pointer"
    mogura.addEventListener("click", () => {
      // if(this.canvas.isMouseDown)return;
      mogura.play()
    })
  }

  initHouse1 (house, modals) {
    this.disabledDrag(house);
    house.cursor = "pointer";
    house.addEventListener("rollover", () => {
      house.pop.play();
    });
    house.addEventListener("click", () => {
      // if(this.canvas.isMouseDown)return;
      this.exportRoot.modals.visible = true;
    });
    modals.cursor = "auto";
    modals.btn_close.cursor = "pointer";
    modals.addEventListener("click", () => {
      // if(this.canvas.isMouseDown)return;
      modals.visible = false;
    });
    modals.addEventListener("rollover", (e) => {
      this.actions.setNumMouseOver(1);
    });
    modals.addEventListener("rollout", (e) => {
      this.actions.setNumMouseOver(-1);
    });

  }

  initHouse2 (house) {
    this.disabledDrag(house);
    house.cursor = "pointer";
    house.addEventListener("rollover", () => {
      house.pop.play();
    });
    house.addEventListener("click", () => {
      window.open("./movie-spec/", "_blank")
    });
 

  }

  // initCursor (arrow) {
  //   const stage = this.stage;
  //   arrow.x = stage.mouseX;
  //   arrow.y = stage.mouseY;
  //   arrow.visible = true;
  //   // setTimeout(() => {
  //     // arrow.play();
  //   // }, 1500);
  //
  //   let isEnter = false;
  //
  //   $("#canvas").on("mouseenter mouseleave", (e) => {
  //     // if(e.type==="mousemove" && !isEnter) {
  //     //   isEnter = true;
  //     //   return;
  //     // }
  //     isEnter = e.type === "mouseenter";
  //   });
  //
  //   createjs.Ticker.addEventListener("tick", () => {
  //     const mouseX = stage.mouseX - this.exportRoot.x;
  //     const mouseY = stage.mouseY - this.exportRoot.y;
  //     const ax = arrow.x;
  //     const ay = arrow.y;
  //    
  //
  //     if (mouseX !== ax) {
  //       arrow.x = mouseX;
  //     }
  //     if (mouseY !== ay) {
  //       arrow.y = mouseY;
  //     }
  //    
  //     let isBusy = false;
  //    
  //     if(this.canvas.isMouseDown) {
  //       this.isVisible = true;
  //     } else {
  //       this.isVisible = false;
  //     }
  //
  //     if (isEnter && this.isVisible) {
  //       this.isVisible = true;
  //     } else {
  //       this.isVisible = false;
  //
  //     }
  //    
  //     if(this.canvas.numMouseOver <= 0 && this.isVisible) {
  //       this.isVisible = true;
  //
  //     } else {
  //       this.isVisible = false;
  //
  //     }
  //     if(this.isVisible !== arrow.visible && !isBusy) {
  //       isBusy = true;
  //       createjs.Tween.removeTweens(arrow);
  //       // if(this.isVisible) {
  //       //   arrow.alpha = 0;
  //       //   arrow.visible = true;
  //       //   createjs.Tween
  //       //     .get(arrow)
  //       //     // .wait(200)
  //       //     .to({alpha:1}, 100, createjs.Ease.sineOut)
  //       //     .call(()=>{
  //       //       isBusy = false;
  //       //     });
  //       // } else {
  //       //   isBusy = false;
  //       //   arrow.alpha = 0;
  //       //   arrow.visible = false;
  //       // }
  //       if(this.isVisible) {
  //         arrow.alpha = 1;
  //         arrow.visible = true;
  //         isBusy = false;
  //       } else {
  //         isBusy = false;
  //         arrow.alpha = 0;
  //         arrow.visible = false;
  //       }
  //      
  //     }
  //    
  //    
  //   });
  // }

  initMoveCursor (move_arrow_l, move_arrow_r) {
    const stage = this.stage;
    move_arrow_l.y = move_arrow_r.y = 630;
    
    this.disabledDrag(move_arrow_l);
    this.disabledDrag(move_arrow_r);
    move_arrow_l.cursor = move_arrow_r.cursor = "pointer"
    // move_arrow_l.x = 0;
    // move_arrow_l.addEventListener("added", function(e) {
      // console.log(move_arrow_l.parent.removeChild);
      // move_arrow_l.parent.removeChild(move_arrow_l);
      // stage.addChild(move_arrow_l);
      // console.log("added", move_arrow_l.parent.removeChild, move_arrow_l.parent.parent === stage);
      // e.remove();
    // });
    // move_arrow_r.addEventListener("added", (e)=>{
    //   stage.addChild(move_arrow_r);
    //   console.log("added", move_arrow_r.parent.parent);
    //   e.remove();
    // });
   
    createjs.Ticker.addEventListener("tick", () => {
      const lx = -this.exportRoot.x + 40;
      if(move_arrow_l.x !== lx) {
         move_arrow_l.x = lx;
      }
      
      const iw = window.document.documentElement.clientWidth;
      const rx = -this.exportRoot.x + iw - 40;
      if(move_arrow_r.x !== rx) {
        move_arrow_r.x = rx;
      }


      const scrollPosition = this.canvas.scrollPosition
      // if(scrollPosition.inRange) {
      //    if(move_arrow_l.visible) {
      //      move_arrow_l.visible = false
      //    }
      //   if(move_arrow_r.visible) {
      //     move_arrow_r.visible = false
      //   }
      // } else {
        if(move_arrow_l.visible && scrollPosition.isMin) {
          move_arrow_l.visible = false
        } else if(!move_arrow_l.visible && !scrollPosition.isMin) {
          move_arrow_l.visible = true
        }
        if(move_arrow_r.visible && scrollPosition.isMax) {
          move_arrow_r.visible = false
        } else if(!move_arrow_r.visible && !scrollPosition.isMax) {
          move_arrow_r.visible = true
        }
      // }
    });
  }

  changeCanvas (canvas) {
    this.canvas = canvas
  }

  disabledDrag (elem) {
    elem.addEventListener("rollover", (e) => {
      this.actions.setNumMouseOver(1);
    });
    elem.addEventListener("rollout", (e) => {
      this.actions.setNumMouseOver(-1);
    });
    elem.addEventListener("mousedown", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    elem.addEventListener("pressup", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    elem.addEventListener("pressmove", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  startHouse () {
    const duration = 1000;
    const container = this.exportRoot.container;
    const house_1 = container.house_1;
    const house_2 = container.house_2;
    house_1.pop.scaleX = house_2.pop.scaleX = 0;
    house_1.pop.scaleY = house_2.pop.scaleY = 0;
    house_1.pop.visible = house_2.pop.visible = true;
    createjs.Tween.get(house_1.pop).wait(duration).to({ scaleX: 1, scaleY: 1 }, 800, createjs.Ease.backOut)
    createjs.Tween.get(house_2.pop).wait(duration).to({ scaleX: 1, scaleY: 1 }, 800, createjs.Ease.backOut)
  }

}


/** WEBPACK FOOTER **
 ** ./src/components/canvas/MCAnimations.js
 **/